module.exports = __webpack_public_path__ + "img/agents_story_card2.a18b7117.svg";